
const ZFRESPOND_JST = {};

const { requireAllAsJst } = require('zoomforth_legacy_jst/jst_builder.js');

requireAllAsJst(ZFRESPOND_JST, require.context('!!raw-loader!zoomforth_zfrespond/views/', false, /.+\.tpl/));

module.exports = ZFRESPOND_JST;